import { render } from "./ProfileSettings.vue?vue&type=template&id=abdb45f4"
import script from "./ProfileSettings.vue?vue&type=script&lang=js"
export * from "./ProfileSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__